import React from 'react'
import { getImages } from '../Components/const'
import VdpNewVideo from '../Components/VdpNew/VdpNewVideo'
import UseScrollReveal from '../Components/Common/UseScrollReveal '

const VdpNew = () => {
    UseScrollReveal();
    return (
        <>
            <section className='vdp-new-banner-wrap'>
                <img className='w-100' src={getImages('vdp-new-bg.jpg')} alt='vdp' />
                <div className='vdpn-bottom'>
                    <div className='container'>
                        <div className='d-flex align-items-center justify-content-between vdpn-b-flex'>
                            <div className='d-flex align-items-center wow reveal fadeInLeft'>
                                <div className='me-lg-4 me-3'><img src={getImages('mclaren-svgrepo-com.svg')} /></div>
                                <div className='lg-title fw-300 text-uppercase font-3-2em'>Artura Spider</div>
                            </div>
                            <div className='d-flex align-items-center vdpn-b-right wow reveal fadeInRight'>
                                <div className='me-lg-5 me-3 d-sm-block d-flex'>
                                    <div className='xs-title opacity-0-5'>Price</div>
                                    <div className='lg-title text-uppercase'>$265,888</div>
                                </div>
                                <div>
                                    <a href='#' className='theme-btn text-uppercase fw-bold vdpn-inquire-btn d-inline-block'>Inquire</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='vdp-new-gallery-wrap'>
                <div className='container'>
                    <div className='row g-lg-5 g-3'>
                        <div className='col-md-6 wow reveal fadeInUp'>
                            <div className='vdpn-gallery-box'>
                                <img src={getImages('vdp-thumb1.jpg')} />
                            </div>
                        </div>
                        <div className='col-md-6 wow reveal fadeInUp'>
                            <div className='vdpn-gallery-box'>
                                <img src={getImages('vdp-thumb2.jpg')} />
                            </div>
                        </div>
                        <div className='col-md-6 wow reveal fadeInUp'>
                            <div className='vdpn-gallery-box'>
                                <img src={getImages('vdp-thumb3.jpg')} />
                            </div>
                        </div>
                        <div className='col-md-6 wow reveal fadeInUp'>
                            <div className='vdpn-gallery-box'>
                                <img src={getImages('vdp-thumb4.jpg')} />
                            </div>
                        </div>
                        <div className='col-md-6 wow reveal fadeInUp'>
                            <div className='vdpn-gallery-box'>
                                <img src={getImages('vdp-thumb5.jpg')} />
                            </div>
                        </div>
                        <div className='col-md-6 wow reveal fadeInUp'>
                            <div className='vdpn-gallery-box'>
                                <img src={getImages('vdp-thumb6.jpg')} />
                                <div className='vdpn-more-count lg-title font-2em'>+20</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='vdpn-special-offer-wrap'>
                <div className='container'>
                    <div className='px-lg-5 d-sm-flex align-items-center justify-content-between'>
                        <div className='mb-sm-0 mb-3 wow reveal fadeInLeft'>
                            <div className='xs-title text-orange text-uppercase'>Special Offer</div>
                            <div className='lg-title fw-300 text-uppercase mt-1'>Free PICKUP & DELIVERY</div>
                        </div>
                        <div className='wow reveal fadeInRight'>
                            <a href='#' className='theme-btn text-uppercase w-240 d-inline-block'>Inquire</a>
                        </div>
                    </div>
                </div>
            </section>
            <section className='vdpn-video-wrap'>
                <div className='container wow reveal fadeInUp'>
                    <VdpNewVideo/>
                </div>
            </section>
            <section className='vdpn-about-info-wrap'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-6 ps-lg-5 order-lg-2 mb-lg-0 mb-4'>
                            <ul className='vdpn-list'>
                                <li className='wow reveal fadeInUp'>
                                    <div className='xs-title text-orange text-uppercase'>Top Speed</div>
                                    <div className='lg-title font-2em text-uppercase'>204 mph</div>
                                </li>
                                <li className='wow reveal fadeInUp'>
                                    <div className='xs-title text-orange text-uppercase'>Horsepower</div>
                                    <div className='lg-title font-2em text-uppercase'>562 hp</div>
                                </li>
                                <li className='wow reveal fadeInUp'>
                                    <div className='xs-title text-orange text-uppercase'>Torque</div>
                                    <div className='lg-title font-2em text-uppercase'>443 lb-ft</div>
                                </li>
                                <li className='wow reveal fadeInUp'>
                                    <div className='xs-title text-orange text-uppercase'>0-62 mph</div>
                                    <div className='lg-title font-2em text-uppercase'>3.2 sec</div>
                                </li>
                                <li className='wow reveal fadeInUp'>
                                    <div className='xs-title text-orange text-uppercase'>Engine Layout</div>
                                    <div className='lg-title font-2em text-uppercase'>3.8L V8</div>
                                </li>
                            </ul>
                        </div>
                        <div className='col-lg-6 pe-lg-5'>
                            <div className='lg-title fw-300 text-uppercase wow reveal fadeInUp'>About this Vehicle</div>
                            <div className='vdpn-ai-content wow reveal fadeInUp'>
                                <p>This one of a kind machine  clocks 0 - 60 in 4.5 seconds only one previous owner and only 600 have ever been made.  Its the perfect perfect piece for any collector lorem ipsum dolor sit amet, adipiscing elit, duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. aliqua.</p>
                                <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                            </div>
                            <div className='d-sm-flex align-items-center mt-5 wow reveal fadeInUp'>
                                <div className='me-sm-5 mb-sm-0 mb-4'>
                                    <a href="tel:4079880111" className="sub-sm-btn text-uppercase d-inline-block w-240">407-988-0111</a>
                                </div>
                                <div>
                                    <a href="tel:4079880111" className="theme-btn text-uppercase d-inline-block w-240">Inquire</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default VdpNew